import React from 'react';
import ErrorAwareRoute from '@Generic/SaplingRoute/ErrorAwareRoute';
import { Redirect } from 'react-router-dom';

export default () => (
  <ErrorAwareRoute
    render={({ location }) => (
      <Redirect
        to={{
          pathname: '/login',
          state: { from: location },
        }}
      />
    )}
  />
);
